import { GetRequest } from "@/api/service"

const ControllerName = "AccountManager"

export const getAllBrokers = () =>
    GetRequest(`${ControllerName}/lookup`)

export const getMyAccountManagerBrokers = () =>
    GetRequest(`${ControllerName}/get-account-manager-brokers`)